import { AnyAction } from 'redux'

const moduleName = 'MMB/lastLocation'

export enum LastLocationActionType {
  UPDATE_LAST_LOCATION = 'UPDATE_LAST_LOCATION',
}

const initialState = {
  pathname: '',
  search: '',
  hash: '',
  key: '',
  state: {},
}

export default function reducer(
  state: LastLocationState = initialState,
  action: AnyAction,
): LastLocationState {
  switch (action.type) {
    case `${moduleName}/${LastLocationActionType.UPDATE_LAST_LOCATION}`:
      return {
        ...state,
        ...action.location,
      }
    default:
      return state
  }
}

export function updateLastLocationAction(location: LastLocationState) {
  return {
    type: `${moduleName}/${LastLocationActionType.UPDATE_LAST_LOCATION}`,
    location,
  }
}

export type LastLocationState = {
  pathname: string
  search: string
  hash: string
  key: string
  state: object
}
